// Libs
import { ModelBase } from "@shoothill/core";
import { FamilyAddressDTO } from "Globals/Models/DTO/FamilyAddressDTO";
// App
import { PersonalDetailsDTO } from "Globals/Models/DTO/PersonalDetailsDTO";
import { PreviousAddressDTO } from "Globals/Models/DTO/PreviousAddressDTO";
import * as MobX from "mobx";
import { FamilyAddressModel } from "./FamilyAddressModel";
import { PreviousAddressModel } from "./PreviousAddressModel";

export class PersonalDetailsModel extends ModelBase<PersonalDetailsModel, PersonalDetailsAndRelated> {
    @MobX.observable public id: string | null = null;
    @MobX.observable public formId: string = "";
    @MobX.observable public applicantId: string = "";
    @MobX.observable public relationshipTypeId: string | null = "placeholder";
    @MobX.observable public title: string = "placeholder";
    @MobX.observable public firstName: string = "";
    @MobX.observable public middleName: string = "";
    @MobX.observable public lastName: string = "";
    @MobX.observable public dateOfBirth: Date | null = null;
    @MobX.observable public addressLine1: string = "";
    @MobX.observable public addressLine2: string = "";
    @MobX.observable public addressLine3: string = "";
    @MobX.observable public city: string = "";
    @MobX.observable public county: string = "";
    @MobX.observable public postcode: string = "";
    @MobX.observable public yearsAtAddress: number = 0;
    @MobX.observable public monthsAtAddress: number = 0;
    @MobX.observable public livedElsewhereInLastThreeYears: boolean = true;
    @MobX.observable public homeTelephone: string = "";
    @MobX.observable public mobileTelephone: string = "";
    @MobX.observable public email: string = "";
    @MobX.observable public localAuthorityId: string = "placeholder";
    @MobX.observable public workLocalAuthorityId: string = "placeholder";
    @MobX.observable public immediateFamilyInLocalAuthority: boolean = true;
    @MobX.observable public employed: boolean = true;
    @MobX.observable public hasOwnedPropertyInUKorAbroad: boolean = true;
    @MobX.observable public createdDate: Date | null = null;
    @MobX.observable public isDeleted: boolean = false;

    // Previous Address
    @MobX.observable public previousAddressModels: PreviousAddressModel[] = [];
    // Family Address
    @MobX.observable public familyAddressModels: FamilyAddressModel[] = [];

    @MobX.action
    public fromDto = (model: PersonalDetailsAndRelated): void => {
        if (model !== null && model !== undefined) {
            this.id = model.personalDetails.id;
            this.formId = model.personalDetails.formId;
            this.applicantId = model.personalDetails.applicantId;
            this.relationshipTypeId =
                model.personalDetails.relationshipTypeId == "" || model.personalDetails.relationshipTypeId == null ? "placeholder" : model.personalDetails.relationshipTypeId;
            this.title = model.personalDetails.title == "" ? "placeholder" : model.personalDetails.title;
            this.firstName = model.personalDetails.firstName;
            this.middleName = model.personalDetails.middleName;
            this.lastName = model.personalDetails.lastName;
            this.dateOfBirth = model.personalDetails.dateOfBirth;
            this.addressLine1 = model.personalDetails.addressLine1;
            this.addressLine2 = model.personalDetails.addressLine2;
            this.addressLine3 = model.personalDetails.addressLine3;
            this.city = model.personalDetails.city;
            this.county = model.personalDetails.county;
            this.postcode = model.personalDetails.postcode;
            this.yearsAtAddress = model.personalDetails.yearsAtAddress;
            this.monthsAtAddress = model.personalDetails.monthsAtAddress;
            this.livedElsewhereInLastThreeYears = model.personalDetails.livedElsewhereInLastThreeYears;
            this.homeTelephone = model.personalDetails.homeTelephone;
            this.mobileTelephone = model.personalDetails.mobileTelephone;
            this.email = model.personalDetails.email;
            this.localAuthorityId = model.personalDetails.localAuthorityId == "" ? "placeholder" : model.personalDetails.localAuthorityId;
            this.workLocalAuthorityId = model.personalDetails.workLocalAuthorityId == "" ? "placeholder" : model.personalDetails.workLocalAuthorityId;
            this.immediateFamilyInLocalAuthority = model.personalDetails.immediateFamilyInLocalAuthority;
            this.employed = model.personalDetails.employed;
            this.hasOwnedPropertyInUKorAbroad = model.personalDetails.hasOwnedPropertyInUKorAbroad;
            this.createdDate = model.personalDetails.createdDate;
            this.isDeleted = model.personalDetails.isDeleted;

            // Load previous Address
            model.previousAddressModels.forEach((previousAddress) => {
                let localPreviousAddressModel: PreviousAddressModel = new PreviousAddressModel();
                // Load the personal details for each applicant
                localPreviousAddressModel.fromDto(previousAddress);
                this.previousAddressModels.push(localPreviousAddressModel);
            });

            // Load family Address
            model.familyAddressModels.forEach((familyAddress) => {
                let localFamilyAddressModel: FamilyAddressModel = new FamilyAddressModel();
                // Load the personal details for each applicant
                localFamilyAddressModel.fromDto(familyAddress);
                this.familyAddressModels.push(localFamilyAddressModel);
            });
        }
    };

    @MobX.action
    public fromPersonalDetailsDto = (model: PersonalDetailsDTO): void => {
        if (model !== null && model !== undefined) {
            this.id = model.id;
            this.formId = model.formId;
            this.applicantId = model.applicantId;
            this.relationshipTypeId = model.relationshipTypeId == "" || model.relationshipTypeId == null ? "placeholder" : model.relationshipTypeId;
            this.title = model.title == "" ? "placeholder" : model.title;
            this.firstName = model.firstName;
            this.middleName = model.middleName;
            this.lastName = model.lastName;
            this.dateOfBirth = model.dateOfBirth;
            this.addressLine1 = model.addressLine1;
            this.addressLine2 = model.addressLine2;
            this.addressLine3 = model.addressLine3;
            this.city = model.city;
            this.county = model.county;
            this.postcode = model.postcode;
            this.yearsAtAddress = model.yearsAtAddress;
            this.monthsAtAddress = model.monthsAtAddress;
            this.livedElsewhereInLastThreeYears = model.livedElsewhereInLastThreeYears;
            this.homeTelephone = model.homeTelephone;
            this.mobileTelephone = model.mobileTelephone;
            this.email = model.email;
            this.localAuthorityId = model.localAuthorityId == "" ? "placeholder" : model.localAuthorityId;
            this.workLocalAuthorityId = model.workLocalAuthorityId == "" ? "placeholder" : model.workLocalAuthorityId;
            this.immediateFamilyInLocalAuthority = model.immediateFamilyInLocalAuthority;
            this.employed = model.employed;
            this.hasOwnedPropertyInUKorAbroad = model.hasOwnedPropertyInUKorAbroad;
            this.createdDate = model.createdDate;
            this.isDeleted = model.isDeleted;
        }
    };

    @MobX.action
    public toDto = (): PersonalDetailsDTO => {
        let model: PersonalDetailsDTO = {
            id: this.id,
            formId: this.formId,
            applicantId: this.applicantId,
            relationshipTypeId: this.relationshipTypeId == "placeholder" ? null : this.relationshipTypeId,
            title: this.title == "placeholder" ? "" : this.title,
            firstName: this.firstName,
            middleName: this.middleName,
            lastName: this.lastName,
            dateOfBirth: this.dateOfBirth,
            addressLine1: this.addressLine1,
            addressLine2: this.addressLine2,
            addressLine3: this.addressLine3,
            city: this.city,
            county: this.county,
            postcode: this.postcode,
            yearsAtAddress: this.yearsAtAddress,
            monthsAtAddress: this.monthsAtAddress,
            livedElsewhereInLastThreeYears: this.livedElsewhereInLastThreeYears,
            homeTelephone: this.homeTelephone,
            mobileTelephone: this.mobileTelephone,
            email: this.email,
            localAuthorityId: this.localAuthorityId == "placeholder" ? "" : this.localAuthorityId,
            workLocalAuthorityId: this.workLocalAuthorityId == "placeholder" ? "" : this.workLocalAuthorityId,
            employed: this.employed,
            immediateFamilyInLocalAuthority: this.immediateFamilyInLocalAuthority,
            hasOwnedPropertyInUKorAbroad: this.hasOwnedPropertyInUKorAbroad,
            createdDate: this.createdDate,
            isDeleted: this.isDeleted,
        };
        return model;
    };
}

// Extend interface to accept new form sections
export interface PersonalDetailsAndRelated {
    personalDetails: PersonalDetailsDTO;
    previousAddressModels: PreviousAddressDTO[];
    familyAddressModels: FamilyAddressDTO[];
}
